module.exports = __webpack_public_path__ + "img/consultation_banner.ba1f7ed9.png";